import React, { useState } from "react";
import styles from "./styles.module.scss";
import { Avatar, Button, Input } from "antd";
import { SearchOutlined, TagFilled } from "@ant-design/icons";
import { Space, Table, Tag } from "antd";
import { CPUIcon, Error, Tick, ViewDetailsIcon } from "icons";
import { getDatatableWidth } from "pages/history/listing/helpers";
import { Link } from "react-router-dom";

export const ComputersTable = ({ setOpenDetailModal }) => {
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(15);

  const columns = [
    {
      title: "No.",
      dataIndex: "key",
      key: "key",
      render: (text, record, index) => {
        const globalIndex = ((currentPage || 1) - 1) * pageSize + index + 1;
        return index < 9 && currentPage === 1 ? `0${index + 1}` : globalIndex;
      },
      width: "3%",
      fixed: "left",
    },
    {
      title: "Country",
      dataIndex: "country",
      key: "country",

      render: (text) => (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: 8,
            justifyContent: "center",
          }}
        >
          <Avatar src="https://avatar.iran.liara.run/public/68"></Avatar>
          <span>{text}</span>
        </div>
      ),
    },

    {
      title: "No. of Users",
      colSpan: 2,
      dataIndex: "number",
      width: "5%",
      onCell: () => ({
        className: styles["grouped-cell-left"],
      }),
      render: (text) => (
        <div
          style={{
            border: "1px solid lightGrey",
            borderRadius: "4px",
            boxShadow: "0px 0px 4px 0px #00000040",
          }}
        >
          {text}
        </div>
      ),
    },
    {
      title: "Percentage",
      width: "5%",
      colSpan: 0,
      dataIndex: "percentage",
      onCell: () => ({
        className: styles["grouped-cell-right"],
      }),
      render: (text) => (
        <div
          style={{
            border: "1px solid lightGrey",
            borderRadius: "4px",
            boxShadow: "0px 0px 4px 0px #00000040",
          }}
        >
          {text}
        </div>
      ),

      // onCell: sharedOnCell,
    },
    {
      title: "iOS",
      dataIndex: "iOS",
      number: 11,
      percentage: "2%",
      key: "iOS",
    },

    {
      title: "Android",
      dataIndex: "android",
      key: "android",
    },
    {
      title: "Studio",
      dataIndex: "studio",
      key: "studio",
    },
  ];
  const data = [
    {
      key: "1",
      country: "pakistan",
      noOfUsers: "Alina Cristino",
      number: 11,
      percentage: "2%",
      iOS: 11,
      android: 11,
      studio: 11,
    },
    {
      key: "2",
      country: "pakistan",
      noOfUsers: "Alina Cristino",
      number: 11,
      percentage: "2%",
      iOS: 11,
      android: 11,
      studio: 11,
    },
    {
      key: "3",
      country: "pakistan",
      noOfUsers: "Alina Cristino",
      number: 11,
      percentage: "2%",
      iOS: 11,
      android: 11,
      studio: 11,
    },
    {
      key: "4",
      country: "pakistan",
      noOfUsers: "Alina Cristino",
      number: 11,
      percentage: "2%",
      iOS: 11,
      android: 11,
      studio: 11,
    },
    {
      key: "5",
      country: "pakistan",
      noOfUsers: "Alina Cristino",
      number: 11,
      percentage: "2%",
      iOS: 11,
      android: 11,
      studio: 11,
    },
    {
      key: "6",
      country: "pakistan",
      noOfUsers: "Alina Cristino",
      number: 11,
      percentage: "2%",
      iOS: 11,
      android: 11,
      studio: 11,
    },
    {
      key: "7",
      country: "pakistan",
      noOfUsers: "Alina Cristino",
      number: 11,
      percentage: "2%",
      iOS: 11,
      android: 11,
      studio: 11,
    },
    {
      key: "8",
      country: "pakistan",
      noOfUsers: "Alina Cristino",
      number: 11,
      percentage: "2%",
      iOS: 11,
      android: 11,
      studio: 11,
    },
    {
      key: "9",
      country: "pakistan",
      noOfUsers: "Alina Cristino",
      number: 11,
      percentage: "2%",
      iOS: 11,
      android: 11,
      studio: 11,
    },
    {
      key: "10",
      country: "pakistan",
      noOfUsers: "Alina Cristino",
      number: 11,
      percentage: "2%",
      iOS: 11,
      android: 11,
      studio: 11,
    },
    {
      key: "11",
      country: "pakistan",
      noOfUsers: "Alina Cristino",
      number: 11,
      percentage: "2%",
      iOS: 11,
      android: 11,
      studio: 11,
    },
    {
      key: "12",
      country: "pakistan",
      noOfUsers: "Alina Cristino",
      number: 11,
      percentage: "2%",
      iOS: 11,
      android: 11,
      studio: 11,
    },
    {
      key: "13",
      country: "pakistan",
      noOfUsers: "Alina Cristino",
      number: 11,
      percentage: "2%",
      iOS: 11,
      android: 11,
      studio: 11,
    },
    {
      key: "14",
      country: "pakistan",
      noOfUsers: "Alina Cristino",
      number: 11,
      percentage: "2%",
      iOS: 11,
      android: 11,
      studio: 11,
    },
    {
      key: "15",
      country: "pakistan",
      noOfUsers: "Alina Cristino",
      number: 11,
      percentage: "2%",
      iOS: 11,
      android: 11,
      studio: 11,
    },
  ];
  function handleChatSearch() {
    console.log("hii");
  }
  return (
    <div className={styles.tableContainer}>
      <div className={styles.searchContainer}>
        <div className={styles.textContainer}>
          <h3>Geographical User Insights</h3>
        </div>
        <div className={styles.messageSearch}>
          <Input
            placeholder="Search"
            onChange={handleChatSearch}
            prefix={<SearchOutlined />}
            // value={filterInput}
          />
        </div>
      </div>
      <Table
        // bordered
        columns={columns}
        dataSource={data}
        rowClassName={styles.row}
        scroll={{
          y:
            window.innerWidth > 1600
              ? `calc(86dvh - 255px)`
              : `calc(71dvh - 230px)`,
          x: getDatatableWidth(),
        }} // Set the width for horizontal scrolling
        style={{ width: "100%" }}
        className={styles.table}
        sticky={true}
        pagination={false}
        // pagination={{
        //   position: ["bottomCenter"],
        //   pageSize: pageSize,
        //   current: currentPage,
        // }}
      />
    </div>
  );
};
